/**
 * The Windows setup script, as text rather than a file in public/.
 *
 * It used to ship as public/kasa-kurulum.bat, but Firebase Hosting refuses to
 * publish executables on the Spark plan, with the .bat in the build output no
 * deploy could go out at all. Held here and handed to the browser as a Blob,
 * the download is identical for whoever presses the button and there is no
 * executable in dist for Hosting to object to.
 *
 * CRLF on purpose: cmd.exe mis-parses a batch file with bare LF endings.
 */

import BRIDGE_PS1 from './bridge/yazici-koprusu.ps1?raw'

/** Where the shortcut points. Update this when the app moves domain. */
const APP_URL = 'https://adissoo.com'

const SCRIPT = String.raw`@echo off
chcp 65001 >nul
title Adissoo - Kurulum

REM Creates a desktop shortcut that opens the till in Chrome's kiosk printing
REM mode, where window.print() goes straight to the default printer instead of
REM raising the print dialog. A web page cannot skip that dialog on its own,
REM it is a browser security rule, so the switch has to come from the command
REM line that starts Chrome.

echo.
echo   ADISSOO - YAZICI KURULUMU
echo   ==========================
echo.

REM Chrome's install path differs between machine-wide and per-user installs.
set "CHROME="
if exist "%ProgramFiles%\Google\Chrome\Application\chrome.exe" set "CHROME=%ProgramFiles%\Google\Chrome\Application\chrome.exe"
if exist "%ProgramFiles(x86)%\Google\Chrome\Application\chrome.exe" set "CHROME=%ProgramFiles(x86)%\Google\Chrome\Application\chrome.exe"
if exist "%LocalAppData%\Google\Chrome\Application\chrome.exe" set "CHROME=%LocalAppData%\Google\Chrome\Application\chrome.exe"

if not defined CHROME (
  echo   [HATA] Google Chrome bulunamadi.
  echo.
  echo   Once Chrome'u kurun: https://www.google.com/chrome/
  echo.
  pause
  exit /b 1
)

echo   Chrome bulundu:
echo   %CHROME%
echo.

set "SHORTCUT=%USERPROFILE%\Desktop\Adissoo.lnk"

REM PowerShell writes the .lnk; cmd has no way to create one itself. Written to
REM a temporary .ps1 rather than passed with -Command: several tightly quoted
REM fragments on one command line are handled inconsistently across Windows
REM versions, and a file has no quoting to get wrong.
set "PS1=%TEMP%\adissoo-kasa-kisayol.ps1"

REM Parentheses are cmd metacharacters even inside echo, so they are escaped.
> "%PS1%" echo $s = ^(New-Object -ComObject WScript.Shell^).CreateShortcut^("%SHORTCUT%"^)
>>"%PS1%" echo $s.TargetPath = "%CHROME%"
>>"%PS1%" echo $s.Arguments = "--kiosk-printing --app=__APP_URL__"
>>"%PS1%" echo $s.IconLocation = "%CHROME%,0"
>>"%PS1%" echo $s.Description = "Adissoo kasa - fisler yazdirma penceresi cikmadan basilir"
>>"%PS1%" echo $s.Save^(^)

powershell -NoProfile -ExecutionPolicy Bypass -File "%PS1%"
set "PSEXIT=%ERRORLEVEL%"
del "%PS1%" >nul 2>&1

if not "%PSEXIT%"=="0" (
  echo   [HATA] Kisayol olusturulamadi.
  echo.
  pause
  exit /b 1
)

echo   [TAMAM] Masaustune "Adissoo" kisayolu olusturuldu.
echo.

REM Yazici Koprusu (20 Eki 2026): Ethernet'li fis yazicilarina basmak icin
REM arka planda calisan kucuk program. Kodu satir satir bir dosyaya yaziliyor
REM (tek satira sigmiyor), PowerShell onu cozup .ps1 yapiyor. Eski surum
REM calisiyorsa once durduruluyor, yoksa yenisi port dolu diye acilmaz.
set "KOPRU=%LocalAppData%\Adissoo"
if not exist "%KOPRU%" mkdir "%KOPRU%"
set "B64=%KOPRU%\kopru.b64"
__KOPRU_B64__
powershell -NoProfile -ExecutionPolicy Bypass -Command "try { $null = Invoke-WebRequest -UseBasicParsing -TimeoutSec 2 -Uri 'http://127.0.0.1:17777/kapat' } catch {}"
powershell -NoProfile -ExecutionPolicy Bypass -Command "[IO.File]::WriteAllBytes($env:KOPRU + '\yazici-koprusu.ps1', [Convert]::FromBase64String([IO.File]::ReadAllText($env:B64)))"
del "%B64%" >nul 2>&1

REM Windows acilisinda gizli pencerede baslasin.
set "STARTUP=%AppData%\Microsoft\Windows\Start Menu\Programs\Startup\Adissoo Yazici Koprusu.lnk"
> "%PS1%" echo $s = ^(New-Object -ComObject WScript.Shell^).CreateShortcut^("%STARTUP%"^)
>>"%PS1%" echo $s.TargetPath = "powershell.exe"
>>"%PS1%" echo $s.Arguments = "-NoProfile -WindowStyle Hidden -ExecutionPolicy Bypass -File ""%KOPRU%\yazici-koprusu.ps1"""
>>"%PS1%" echo $s.WindowStyle = 7
>>"%PS1%" echo $s.Save^(^)
powershell -NoProfile -ExecutionPolicy Bypass -File "%PS1%"
del "%PS1%" >nul 2>&1

start "" /min powershell -NoProfile -WindowStyle Hidden -ExecutionPolicy Bypass -File "%KOPRU%\yazici-koprusu.ps1"
echo   [TAMAM] Yazici Koprusu kuruldu ve calisiyor (Ethernet yazicilar icin).
echo.
echo   SIRADAKI ADIMLAR
echo   ----------------
echo.
echo   1. Termal yaziciyi VARSAYILAN yapin:
echo      Ayarlar - Bluetooth ve cihazlar - Yazicilar ve tarayicilar
echo      Yaziciya sag tik - Varsayilan olarak ayarla
echo.
echo      Kiosk modu her zaman varsayilan yaziciya basar, secim sormaz.
echo.
echo   2. Ayni ekranda yaziciya tiklayin - Yazdirma tercihleri
echo      Kagit boyutu: 80mm
echo.
echo   3. Kasayi masaustundeki "Adissoo" kisayolundan acin.
echo      Normal Chrome'dan acarsaniz yazdirma penceresi yine cikar.
echo.
echo   4. Uygulamada: Ayarlar - Sistem - Otomatik yazdirma: ACIK
echo      Bu ayar sadece bu bilgisayar icin gecerlidir.
echo.
echo   ETHERNET YAZICILAR
echo   ------------------
echo.
echo   Yazicilar kabloyla modeme bagliysa 1. ve 2. adim gerekmez:
echo   Ayarlar - Yazicilar: yazicilari IP adresiyle ekleyin, "Dene" ile
echo   deneyin ve "Bu bilgisayar fisleri ag yazicilarina gondersin": ACIK.
echo   Chrome "yerel agdaki cihazlara erisim" izni sorarsa: Izin ver.
echo.
echo   GUNCELLEME
echo   ----------
echo.
echo   Kasa penceresi gunlerce acik kaldigi icin guncellemeyi kendisi arar
echo   ve buldugunda sessizce gecer. Hemen istiyorsaniz:
echo.
echo      Ctrl + Shift + R      (sayfayi tamamen yeniler)
echo.
echo   Menudeki surum damgasindan hangi surumde oldugunuzu gorebilirsiniz.
echo.
pause
`

/**
 * Köprü programı, bat'ın dosyaya yazacağı base64 satırları olarak. Tek satır
 * cmd'nin 8191 karakter sınırını aşıyor; base64'te cmd için özel karakter yok.
 * BOM'lu UTF-8: Windows PowerShell 5.1 BOM'suz dosyayı Türkçe okumaz.
 */
export function bridgeLines(): string {
  const bytes = new TextEncoder().encode('﻿' + BRIDGE_PS1.replace(/\r?\n/g, '\r\n'))
  let bin = ''
  for (const b of bytes) bin += String.fromCharCode(b)
  const b64 = btoa(bin)
  const lines: string[] = []
  for (let i = 0; i < b64.length; i += 1000) {
    lines.push(`${i === 0 ? '> ' : '>>'}"%B64%" echo ${b64.slice(i, i + 1000)}`)
  }
  return lines.join('\n')
}

/** Hands the browser a .bat built on the spot. */
export function downloadKioskSetup(): void {
  const text = SCRIPT.replace('__APP_URL__', APP_URL)
    .replace('__KOPRU_B64__', bridgeLines())
    .replace(/\n/g, '\r\n')
  // windows-1254 would match the chcp line above, but TextEncoder only speaks
  // UTF-8, which is what chcp 65001 selects, so the two agree.
  const blob = new Blob([text], { type: 'application/octet-stream' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = 'kasa-kurulum.bat'
  a.click()

  // Revoked on the next tick rather than immediately: Safari reads the href
  // after the click handler returns.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
